/* =========================================================
   Carrinho lateral — Vezane
   1) Qualquer link do carrinho ("/cart", com ou sem UTMs)
      abre a gaveta do carrinho.
   2) O "Ver carrinho" do pop-up de produto adicionado
      fecha o pop-up e abre a gaveta.
   O link é reconhecido pelo caminho, porque o Utmify acrescenta
   UTMs ao endereço (ex.: /cart?utm_source=...).
   ========================================================= */

(function () {
  var POPUP = 'quick-buy-drawer';

  function isCartLink(link) {
    if (!link || !link.getAttribute('href')) return false;
    try {
      var url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && url.pathname.replace(/\/+$/, '') === '/cart';
    } catch (e) {
      return false;
    }
  }

  function closestCartLink(target) {
    var link = target && target.closest ? target.closest('a[href]') : null;
    return isCartLink(link) ? link : null;
  }

  /* ---------- 1. Links do carrinho abrem a gaveta ---------- */
  function fix() {
    document.querySelectorAll('a[href*="/cart"]').forEach(function (link) {
      if (!isCartLink(link)) return;

      // links dentro do pop-up ficam de fora: o clique deles é tratado abaixo
      if (link.closest(POPUP)) {
        link.removeAttribute('aria-controls');
        link.dataset.popupClose = '1';
        return;
      }

      if (link.dataset.drawerReady) return;

      link.dataset.drawerReady = '1';
      link.setAttribute('aria-controls', 'cart-drawer');
      link.setAttribute('data-no-instant', '');
    });
  }

  document.addEventListener('DOMContentLoaded', fix);
  new MutationObserver(fix).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  fix();

  /* ---------- 2. "Ver carrinho" dentro do pop-up ---------- */
  function closePopup(popup) {
    var closeBtn =
      (popup.shadowRoot &&
        popup.shadowRoot.querySelector('[part="outside-close-button"], [part="close-button"]')) ||
      popup.querySelector('[is="close-button"]');

    if (closeBtn) {
      closeBtn.click();
      return;
    }

    if (typeof popup.close === 'function') {
      popup.close();
      return;
    }

    popup.removeAttribute('open');
    popup.style.display = 'none';
  }

  function openDrawerIfClosed() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.hasAttribute('open') || drawer.classList.contains('is-open')) return;

    if (typeof drawer.show === 'function') {
      drawer.show();
      return;
    }

    var icon = document.querySelector('[aria-controls="cart-drawer"]:not([href]):not([data-popup-close])');
    if (icon) icon.click();
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = closestCartLink(event.target);
      if (!link) return;

      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return; // sem gaveta (carrinho em página): segue o link normal

      event.preventDefault();
      event.stopImmediatePropagation();

      var popup = link.closest(POPUP);
      if (popup) {
        link.removeAttribute('aria-controls');
        closePopup(popup);
        setTimeout(openDrawerIfClosed, 150);
      } else {
        openDrawerIfClosed();
      }
    },
    true
  );
})();
